import { computed } from 'mobx';

export default class PermissionModel {
  id;
  store;

  constructor(store, permission) {
    this.store = store;
    this.name = permission.name;
    this.resource = permission.resource;
    this.roles = permission.roles;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      resource: this.resource,
      roles: this.roles,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.resource = json.resource;
    this.roles = json.roles;
  }
}



// WEBPACK FOOTER //
// ./src/models/PermissionModel.js